// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e86d73e6","897":"8de9a239"}[chunkId] + ".chunk.js";
};